import UAParser from "ua-parser-js";

export default function useIsSafari(): boolean {
    const userAgent = new UAParser([navigator.userAgent])
    const browser = userAgent.getOS()

    return browser?.name?.toLowerCase()?.includes('ios')
}